import React, { useState } from "react";
import { Modal, Button, Upload } from "antd";
import { CloseOutlined, EyeOutlined, UploadOutlined } from "@ant-design/icons";
import RightSidePreviewModal from "../../modals/RightSidePreviewModal";
import DeleteConfirmationModal from "./DeleteConfirmationModal";

interface Props {
  visible: boolean;
  onClose: () => void;
  documents: any[];
  onDelete: (doc: any, docs: any) => void;
  title?: string;
  documentType: any;
  stage: any;
  isMultiple: boolean;
  handleFileChange: any;
}

const MobileUploadedDocsModal: React.FC<Props> = ({
  visible,
  onClose,
  documents,
  onDelete,
  title = "Documents",
  documentType,
  stage,
  isMultiple,
  handleFileChange,
}) => {
  const [previewDocument, setPreviewDocument] = useState<boolean>(false);
  const [documentUrl, setDocumentUrl] = useState<any>(null);
  const [deleteModalVisible, setDeleteModalVisible] = useState<boolean>(false);
  const [documentToDelete, setDocumentToDelete] = useState<any>(null);
  return (
    <>
      <Modal
        open={visible}
        onCancel={onClose}
        getContainer={document.body}
        footer={null}
        centered
        closable={false}
        width="90%"
        bodyStyle={{
          borderRadius: "20px",
          padding: "6px"
        }}
        style={{zIndex: 9999}}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 18,
          }}
        >
          <h3 style={{ margin: 0, fontSize: 11 }}>{title}</h3>

          <div
            onClick={onClose}
            style={{
              background: "#E6EEF3",
              width: 18,
              height: 18,
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              // cursor: "pointer",
            }}
          >
            <CloseOutlined />
          </div>
        </div>

        {/* Document List */}
        <div style={{ maxHeight: 250, overflowY: "auto" }}>
          {documents?.map((doc, index) => (
            <div
              key={index}
              style={{
                border: "1px solid #E0E0E0",
                borderRadius: 12,
                padding: "6px 8px",
                marginBottom: 10,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{display: "flex", alignItems: "center", maxWidth: "80%",}}>
                <span
                  style={{
                    fontSize: 10,
                    color: "#00395E",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {doc?.documentLabelType ? doc?.documentLabelType + " " + (index + 1) : doc?.documentName}
                </span>
                <EyeOutlined style={{marginLeft: 6,}} onClick={() => {
                    setPreviewDocument(true);
                    setDocumentUrl(doc?.documentUrl);
                }}/>
              </div>

              <CloseOutlined
                onClick={() => {
                  setDocumentToDelete(doc);
                  setDeleteModalVisible(true);
                }}
                style={{color: "#00395E" }}
              />
            </div>
          ))}
        </div>

        {isMultiple ? (
          <Upload
            style={{
              width: "100%",
              marginTop: 10,
              padding: "2px",
            }}
            beforeUpload={() => false}
            onChange={handleFileChange(documentType, stage)}
            maxCount={1}
            showUploadList={false}
          >
            <Button
              icon={<UploadOutlined />}
              block
              style={{
                borderStyle: "dashed",
                height: 45,
                borderRadius: 12,
              }}
            >
              <span style={{ fontSize: 11 }}>Upload Document</span>
            </Button>
          </Upload>
        ) : (
          <></>
        )}
      </Modal>

      <RightSidePreviewModal
        open={previewDocument}
        handleCancel={() => setPreviewDocument(false)}
        documentUrl={documentUrl}
      />

      <DeleteConfirmationModal
        visible={deleteModalVisible}
        onCancel={() => {
          setDeleteModalVisible(false);
          setDocumentToDelete(null);
        }}
        onConfirm={() => {
          if (documentToDelete) {
            onDelete(documentToDelete.documentUrl, documents);
            setDeleteModalVisible(false);
            setDocumentToDelete(null);
          }
        }}
      />
    </>
  );
};

export default MobileUploadedDocsModal;
